export default __webpack_public_path__ + "static/media/icone_quadrado.faecc06b.png";